import React, {useState} from "react";
import {Button, CircularProgress, Dialog, DialogActions, DialogContent} from "@mui/material";
import {ClosableDialogTitle} from "@atttomyx/react-components";
import {CourseForm} from "../forms";
import {courseService} from "../../services";
import {forms} from "@atttomyx/shared-utils";
import {RANK_GOLD, STATUS_DRAFT} from "../../constants";

const freshData = (order) => {
    return {
        name: null,
        description: null,
        imageUrl: null,
        gotoUrl: null,
        gotoLabel: null,
        ranks: [RANK_GOLD],
        status: STATUS_DRAFT,
        order: order,
        music: false,
        valid: false,
    }
};

const AddCourseDialog = (props) => {
    const { snackbar, order, onCancel, onSave } = props;
    const [ data, setData ] = useState(freshData(order));
    const [ saving, setSaving ] = useState(false);

    const submitForm = () => {
        setSaving(true);

        const success = (saved) => {
            snackbar.setSuccess(saved.name + " saved");
            setSaving(false);
            onSave(saved);
        };

        const failure = (err) => {
            snackbar.setError(err);
            setSaving(false);
        };

        const course = {
            name: data.name,
            description: data.description,
            imageUrl: null,
            gotoUrl: data.gotoUrl,
            gotoLabel: data.gotoLabel,
            music: data.music,
            ranks: data.ranks,
            status: data.status,
            order: data.order,
        };

        courseService.createCourse(course, success, failure);
    }

    return <Dialog
        open={true}
        aria-labelledby="add-course-dialog"
    >
        <ClosableDialogTitle onClose={onCancel}>
            Add Module
        </ClosableDialogTitle>
        <DialogContent className="add-course-dialog">
            {saving ?
                <CircularProgress size="40px"/> :
                <CourseForm
                    data={data}
                    onChange={setData}
                />}
        </DialogContent>
        {!saving ? <DialogActions>
            <Button color="primary"
                    disabled={!data.valid || !forms.differ(freshData(order), data)}
                    onClick={submitForm}>
                Save
            </Button>
        </DialogActions> : null}
    </Dialog>
}

export default AddCourseDialog;
